import { themr } from '@friendsofreactjs/react-css-themr';

import SimpleLink from './SimpleLink';

export default themr('SimpleLink')(SimpleLink);
